import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'boothSize',
    'boothSizeButton',
    'date',
    'dateButton',
    'temperature',
    'unitButton'
  ]

  connect () {
    this.renderDates('local')
    this.renderTemperatures('local')
    this.renderBoothSizes(
      this.element.dataset.defaultBoothSizeUnit || 'square_metres'
    )
  }

  changeDate (event) {
    this.renderDates(event.currentTarget.dataset.format || 'local')
  }

  changeTemperature (event) {
    const button = event.currentTarget
    this.renderTemperatures(button.dataset.unit || 'local')
  }

  changeBoothSize (event) {
    this.renderBoothSizes(event.currentTarget.dataset.unit || 'square_metres')
  }

  renderDates (format) {
    this.dateTargets.forEach((target) => {
      const selectedFormat =
        format === 'local' ? target.dataset.defaultFormat : format
      target.textContent = this.formatDate(
        target.dataset.isoDate,
        selectedFormat
      )
    })

    this.dateButtonTargets.forEach((button) => {
      const active = button.dataset.format === format
      button.classList.toggle('is-active', active)
      button.setAttribute('aria-pressed', active.toString())
    })
  }

  renderTemperatures (unit) {
    this.temperatureTargets.forEach((target) => {
      const selectedUnit = unit === 'local' ? target.dataset.defaultUnit : unit
      const celsius = Number(target.dataset.celsius)
      const value =
        selectedUnit === 'fahrenheit' ? (celsius * 9) / 5 + 32 : celsius
      const symbol = selectedUnit === 'fahrenheit' ? 'F' : 'C'
      target.textContent = `${this.round(value)}°${symbol}`
    })

    this.unitButtonTargets.forEach((button) => {
      const active = button.dataset.unit === unit
      button.classList.toggle('is-active', active)
      button.setAttribute('aria-pressed', active.toString())
    })
  }

  renderBoothSizes (unit) {
    this.boothSizeTargets.forEach((target) => {
      target.textContent =
        unit === 'square_feet'
          ? target.dataset.squareFeetLabel
          : target.dataset.squareMetresLabel
    })

    this.boothSizeButtonTargets.forEach((button) => {
      const active = button.dataset.unit === unit
      button.classList.toggle('is-active', active)
      button.setAttribute('aria-pressed', active.toString())
    })
  }

  round (value) {
    return Math.round(value * 10) / 10
  }

  formatDate (isoDate, format) {
    const [year, month, day] = isoDate.split('-')
    return format === 'month-first'
      ? `${month}/${day}/${year}`
      : `${day}/${month}/${year}`
  }
}
